import { ADOBE_BACK_IN_STOCK_IMPRESSION_KEY } from "../../../../../../services/analytics/constants";

const calculateNotifyMeDetails = ({ state }) => {
  if (!state.buttonShownForVariants) {
    return state;
  }

  const notifyMeShownCount = state.buttonShownForVariants.filter(
    variantId => !state.backInStockVariants?.includes(variantId)
  ).length;

  let newState = {
    ...state,
    buttonShownForVariants: undefined
  };

  if (notifyMeShownCount > 0) {
    newState = {
      ...newState,
      trackPage: {
        ...state.trackPage,
        events: [
          ...(state.trackPage?.events ?? []),
          { [ADOBE_BACK_IN_STOCK_IMPRESSION_KEY]: notifyMeShownCount }
        ]
      }
    };
  }

  return newState;
};

export default calculateNotifyMeDetails;
